import axios from "axios"

export async function fetchRelbaseSellers() {
    return await axios.get('relbase/sellers/')
        .then(res => res.data)
        .catch(e => { throw e })
}

export async function fetchRelbaseCategories() {
    return await axios.get('relbase/categories/')
        .then(res => res.data)
        .catch(e => { throw e })
}

export async function fetchRelbaseConfig() {
    return await axios.get('relbase/config/')
        .then(res => res.data)
        .catch(e => { throw e })
}

export async function updateRelbaseConfig(data) {
    return await axios.patch('relbase/config/', data)
        .then(res => res.data)
        .catch(e => { throw e })
}

export async function relbaseHealthCheck() {
    return await axios.get('relbase/health/')
        .then(res => res.data)
        .catch(e => { throw e })
}

export async function syncRelbaseCatalogs() {
    return await axios.post('relbase/sync-catalogs/')
        .then(res => res.data)
        .catch(e => { throw e })
}

export async function syncRelbaseCatalog(catalog) {
    return await axios.post(`relbase/sync-catalogs/${catalog}/`)
        .then(res => res.data)
        .catch(e => { throw e })
}

export async function syncCustomerRelbase(customerId, force = false) {
    return await axios.post('relbase/sync-customer/', { customer_id: customerId, force })
        .then(res => res.data)
        .catch(e => { throw e })
}

export async function fetchRelbaseCities() {
    return await axios.get('relbase/cities/')
        .then(res => res.data)
        .catch(e => { throw e })
}

export async function fetchRelbaseCommunes(cityRelbaseId) {
    return await axios.get('relbase/communes/', { params: { city_id: cityRelbaseId } })
        .then(res => res.data)
        .catch(e => { throw e })
}

export async function lookupCustomerByRUT(rut) {
    return await axios.get('relbase/lookup-customer/', { params: { rut } })
        .then(res => res.data)
        .catch(() => ({ found: false }))
}

export async function syncProductRelbase(productId, force = false) {
    return await axios.post('relbase/sync-product/', { product_id: productId, force })
        .then(res => res.data)
        .catch(e => { throw e })
}

export async function fetchRelbasePaymentMethods() {
    return await axios.get('relbase/payment-methods/')
        .then(res => res.data)
        .catch(e => { throw e })
}

// Story 4.2 — Nuevos catálogos: Bodegas y Canales de Venta
export async function fetchRelbaseWarehouses() {
    return await axios.get('relbase/warehouses/')
        .then(res => res.data)
        .catch(e => { throw e })
}

export async function fetchRelbaseSaleChannels() {
    return await axios.get('relbase/sale-channels/')
        .then(res => res.data)
        .catch(e => { throw e })
}

// Story 4.2 — Historial de documentos emitidos por OT (nuevo endpoint)
export async function fetchIssuedDocumentsByOT(workOrderId) {
    return await axios.get('relbase/documents/', { params: { work_order_id: workOrderId } })
        .then(res => res.data)
        .catch(e => { throw e })
}

export async function lookupProductInRelbase(sku) {
    return await axios.get('relbase/lookup-product/', { params: { sku } })
        .then(res => res.data)
        .catch(() => ({ found: false }))
}

export async function issueRelbaseDTE(payload) {
    return await axios.post('relbase/issue-dte/', payload)
        .then(res => res.data)
        .catch(e => { throw e })
}

// Story 5.3 — Listado centralizado de DTEs emitidos
export async function fetchRelbaseDocuments(params = {}) {
    return await axios.get('relbase/documents/', { params })
        .then(res => res.data)
        .catch(e => { throw e })
}

// Story 5.3 — Detalle de DTE desde Relbase (proxy)
export async function fetchRelbaseDTEDetail(documentId) {
    return await axios.get(`relbase/documents/${documentId}/detail/`)
        .then(res => res.data)
        .catch(e => { throw e })
}

// Story 4.3 — Anular DTE en Relbase
export async function anularRelbaseDTE(documentId) {
    return await axios.post(`relbase/documents/${documentId}/anular/`)
        .then(res => res.data)
        .catch(e => { throw e })
}

// Story 5.2 — Métricas Relbase para el Dashboard
export async function fetchRelbaseMetrics(params = {}) {
    return await axios.get('relbase/dashboard-metrics/', { params })
        .then(res => res.data)
        .catch(e => { throw e })
}

// Story 5.4 & 5.6 — Reports
export async function fetchRelbaseSyncReport(params = {}) {
    return await axios.get('relbase/reports/sync-report/', { params })
        .then(res => res.data)
        .catch(e => { throw e })
}

export async function excelRelbaseSyncReport(query) {
    return await axios.get(`relbase/reports/sync-report/excel/?${query}`, {
        responseType: 'blob',
        timeout: 1000 * 60
    })
        .then(res => res.data)
        .catch(e => { throw e })
}

export async function fetchRelbaseProductBillingReport(params = {}) {
    return await axios.get('relbase/reports/product-billing/', { params })
        .then(res => res.data)
        .catch(e => { throw e })
}

export async function excelRelbaseProductBillingReport(query) {
    return await axios.get(`relbase/reports/product-billing/excel/?${query}`, {
        responseType: 'blob',
        timeout: 1000 * 60
    })
        .then(res => res.data)
        .catch(e => { throw e })
}
